import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    Typography,
    useToastProvider
} from '@deere/fuel-react';
import CampaignsList from "./CampaignsList";
import {Campaign} from "./Campaign";
import {checkedData, searchList, toCapitalizeSplitStr} from '../shared/utils';
import {useAuthConfig} from "../shared/helper";
import SearchIcon from "@material-ui/icons/Search";
import {PersonFilter} from "../shared/filter/PersonFilter";
import {Loading} from "../shared/Loading";
import FeedbackStatusFilter from "../shared/filter/FeedbackStatusFilter";
import FeedbackPeriodFilter from "../shared/filter/FeedbackPeriodFilter";
import { SupplierFilter } from "../shared/filter/SupplierFilter";
import PropTypes from "prop-types"
import {UserContext} from "./Main";

export const Campaigns = ({name}) => {
    let authAxios = useAuthConfig();
    const userInfo = useContext(UserContext);
    const {enqueueToast} = useToastProvider();
    const userId = userInfo && userInfo.userId;
    const userName = userInfo && userInfo.userName;
    const [selectedCreators, setSelectedCreators] = useState([]);
    const [campaignList, setCampaignList] = useState(null);
    const [expanded, setExpanded] = useState(false);
    const [query, setQuery] = useState("");
    const [searchParam] = useState(["title", "status", "dueDate", "responses", "createdBy"]);
    const [isLoading, setIsLoading] = useState(false);
    const [statusExpanded, setStatusExpanded] = useState(false);
    const [completionExpanded, setCompletionExpanded] = useState(false);
    const [periodExpanded, setPeriodExpanded] = useState(false);
    const [statusData, setStatusData] = useState([{id: 1, description: 'Published'}, {id: 2, description: 'Unpublished'}]);
    const [completionStatusData, setCompletionStatusData] = useState([{id: 1, description: 'Complete'}, {id: 2, description: 'Incomplete'}]);
    const [statusFilterData, setStatusFilterData] = useState([]);
    const [completionFilterData,setCompletionFilterData] = useState([]);
    const [campPeriodData, setCampPeriodData] = useState([]);
    const [initStatusFilterData, setInitStatusFilterData] = useState([]);
    const [initPeriodFilterData, setInitPeriodFilterData] = useState([]);
    const [campPeriodFilterData, setCampPeriodFilterData] = useState([]);
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);
    const [expandedSupplier, setExpandedSupplier] = useState(false);

    const toggleStatusFilter = () => {
        setStatusExpanded(!statusExpanded);
    };

    const toggleCompletionFilter = () => {
        setCompletionExpanded(!completionExpanded);
    };

    const togglePeriodFilter = () => {
        setPeriodExpanded(!periodExpanded);
    };

    const handleUpdatedStatus = data => {
        const arr = checkedData(data)
        setStatusFilterData(arr)
    }

    const handleCompletionStatus = data => {
        const arr = checkedData(data)
        setCompletionFilterData(arr)
    }

    const handleUpdatedPeriod = data => {
        const arr = checkedData(data)
        setCampPeriodFilterData(arr)
    }

    const handleSupplierChange = (event) => {
        setSelectedSuppliers(event);
        sessionStorage.setItem("selectedSuppliers", JSON.stringify(event));
    }

    const handleChangeSupplier = (panel) => (event, isExpanded) => {
        setExpandedSupplier(isExpanded ? panel : false);
    };

    const handleSendReminder = (campaignId) => {
        authAxios.post(`/campaign/reminder/${campaignId}`)
            .then(res => {
                console.log(res.data)
                enqueueToast({
                    variant: "success",
                    title: "Reminder email sent",
                    isCloseable: true
                });
            }).catch((error) => {
            console.log(error);
            enqueueToast({
                variant: "error",
                title: "System Error",
                message: error.response ? error.response.data[error.response.status] : "",
                isPersistent: true
            });
        });
    }
    const getCampaignComponent = (list) => {
        return list.map((item, index) => {
            return (
                <Campaign campaign={item} key={index} onSave={handleSendReminder}/>
            );
        });
    }
    const getCampaigns = async (data, suppliersData, query) => {
        setIsLoading(true)
        try {
            const ownerIds = data.length > 0 && data[0].createdBy ? data.map(item => item.createdBy) : selectedCreators.map(item => item.createdBy);
            const supplierNumbers = suppliersData.length > 0 && suppliersData[0].supplierNumber ? suppliersData.map(item => item.supplierNumber) : selectedSuppliers.map(item => item.supplierNumber)
            const searchData = {
                ownerIds: ownerIds,
                supplierNumbers: supplierNumbers,
                searchTerm: query
            }
            return await authAxios.post(`/campaigns/search`, searchData);
        } catch (e) {
            console.error(e);
        }
    };

    const processCampaignComponent = (response) => {
        const updatedData = response.map((row) => {
            const tempSupplierName2 = row.supplierNameLine2 ? row.supplierNameLine2 : "";
            const title = row.title ? row.title : `FY${row.fiscalYear} ${row.period}, ${toCapitalizeSplitStr(row.supplierName)}${tempSupplierName2} - ${parseInt(row.supplierNumber)}`
            const campPeriod = {campPeriod: `${row.fiscalYear}, ${row.period}`}
            const completionPercentage = `${row.responses}`.match(/\((.*)\)/).pop()
            const compPercentage = completionPercentage.slice(0, -1) < 100 ? {compPercentage: "Incomplete"} : {compPercentage: "Complete"}
            const resStatus = {resStatus : `${row.status}` === 'Not Yet Published' ? "Unpublished" : "Published"}
            row = {...title, ...campPeriod, ...compPercentage, ...resStatus, ...row};
            return row;
        });
        const uniqueCampPeriod = [...new Map(updatedData.map(item =>
            [item["campPeriod"], item])).values()]
        const uniquePeriodIds = [...new Set(updatedData.map(item => item.campPeriod))];
        const uniqueStatusIds = [...new Set(updatedData.map(item => item.resStatus))];
        const completionStatus = [...new Set(updatedData.map(item => item.compPercentage))];
        setCampPeriodData(uniqueCampPeriod);
        setCampPeriodFilterData(uniquePeriodIds);
        setInitPeriodFilterData(uniquePeriodIds);
        setInitStatusFilterData(uniqueStatusIds);
        setStatusFilterData(uniqueStatusIds);
        setCompletionFilterData(completionStatus);
        const list = getCampaignComponent(updatedData);
        setIsLoading(false);
        setCampaignList(list);
    }

    const resetFilter = () => {
        const loggedUserInfo = [{createdBy: userId, campaignOwner: userName}]
        setSelectedCreators(loggedUserInfo)
        sessionStorage.setItem("selectedCreators", JSON.stringify(loggedUserInfo));
        setSelectedSuppliers([])
        sessionStorage.setItem("selectedSuppliers", JSON.stringify([]));
        setStatusData(statusData);
        setStatusFilterData(initStatusFilterData);
        setCompletionStatusData(completionStatusData);
        setCampPeriodFilterData(initPeriodFilterData);
    }

    const handleViewResults = async () => {
        setExpanded(false);
        getCampaigns(selectedCreators, selectedSuppliers, query).then(res => {
            processCampaignComponent(res.data)
        });
    }
    const handleOwner = (value) => {
        setSelectedCreators(value);
        sessionStorage.setItem("selectedCreators", JSON.stringify(value));
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const filterCampaignList = (items) => {
        return items && items.filter((item) => {
            return statusFilterData.includes(item.props.campaign.resStatus)
            && completionFilterData.includes(item.props.campaign.compPercentage)
            && campPeriodFilterData.includes(item.props.campaign.campPeriod)
            && searchList(item.props.campaign, searchParam, query)
        })
    }

    useEffect(() => {
        const loggedUserInfo = [{createdBy: userId, campaignOwner: userName}]
        setSelectedCreators(sessionStorage["selectedCreators"]  ? JSON.parse(sessionStorage.getItem("selectedCreators")) : loggedUserInfo)

        if (!sessionStorage["selectedCreators"] || (sessionStorage["selectedCreators"] && JSON.parse(sessionStorage["selectedCreators"]).length > 0 && !JSON.parse(sessionStorage["selectedCreators"])[0].createdBy))
            sessionStorage.setItem("selectedCreators", JSON.stringify(loggedUserInfo));

        const data = sessionStorage["selectedCreators"]  ? JSON.parse(sessionStorage.getItem("selectedCreators")) : loggedUserInfo;
        const suppliersData = sessionStorage["selectedSuppliers"] ? JSON.parse(sessionStorage.getItem("selectedSuppliers")) : selectedSuppliers;

        getCampaigns(data, suppliersData, query).then(res => {
            res && processCampaignComponent(res.data)
        });

        return () => {
            setCampaignList(null);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo]);

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={3}>
                    <Typography variant="h1" component="h1" data-testid="PageName">
                        {name}
                    </Typography>
                </Grid>
                <Grid item xs={9}>
                    <Container>
                        <Box display="flex" justifyContent="flex-end">
                            <Link
                                to={{
                                    pathname: "/campaigns/create-campaign",
                                }}
                                style={{textDecoration: "none"}}
                            >
                                <Button variant="primary" startIcon={<AddIcon/>}>
                                    Create New
                                </Button>
                            </Link>
                        </Box>
                    </Container>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={3}>
                    <Box mt={4}>
                        <Button variant="text-inline" size="large" onClick={resetFilter}>Clear All</Button>
                    </Box>
                    <Box mt={1}>
                        <div className="jdsn-facet-container">
                            <PersonFilter
                                selectedCreators={selectedCreators}
                                onSelectOwner={handleOwner}
                                onExpandClick={handleChange}
                                title={"Campaign Created By"}
                                expanded={expanded}/>

                            <SupplierFilter
                                selectedSuppliers={selectedSuppliers}
                                onOptionsChange={(e) => {
                                    handleSupplierChange(e)
                                }}
                                onExpandClick={handleChangeSupplier}
                                title={"Supplier"}
                                expanded={expandedSupplier}
                            />

                            <FeedbackStatusFilter
                                statusData={statusData}
                                filteredData={statusFilterData}
                                onExpandClick={toggleStatusFilter}
                                onStatusUpdate={handleUpdatedStatus}
                                expanded={statusExpanded}
                                name={"Status"}/>

                            <FeedbackStatusFilter
                                statusData={completionStatusData}
                                filteredData={completionFilterData}
                                onExpandClick={toggleCompletionFilter}
                                onStatusUpdate={handleCompletionStatus}
                                expanded={completionExpanded}
                                name={"Response Completion"}/>

                            <FeedbackPeriodFilter
                                periodData={campPeriodData}
                                filteredData={campPeriodFilterData}
                                onExpandClick={togglePeriodFilter}
                                onPeriodUpdate={handleUpdatedPeriod}
                                expanded={periodExpanded}
                                name={"Campaigns"}
                            />

                            <Box className="fixed-bottom position-sticky view-result">
                                <Button variant="primary" fullWidth={true} size="large" onClick={handleViewResults}>View
                                    Results</Button>
                            </Box>
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={9}>
                    <Container>
                        <Box mt={4}>
                            <FormControl fullWidth>
                                <Input fullWidth placeholder="Filter these results" id="search"
                                       endAdornment={
                                           <InputAdornment position="end">
                                               <IconButton aria-label="search">
                                                   <SearchIcon style={{color: " #367c2b"}}/>
                                               </IconButton>
                                           </InputAdornment>
                                       }
                                       onChange={(e) => setQuery(e.target.value)}/>
                            </FormControl>
                        </Box>
                        <Box mt={4}>
                            {isLoading ?
                                <Loading/> :
                                <CampaignsList list={filterCampaignList(campaignList)}/>
                            }
                        </Box>
                    </Container>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

Campaigns.propTypes = {
  name: PropTypes.string
}
